export const API_URLS = {
  evDataBaseUrl:
    'https://ev-database.org/export_v29/m1/bev/37595818/K9w2fe456yUk2Po0Diq1ej',
  appBackendUrl: 'https://api-stage.ebeecharge.com/graphql',
  apiStrapiUrl: 'https://api-strapi.ebeecharge.com/graphql',
};
